// export const domain = "http://192.168.18.126:9010";
export const domain = "https://backend.fastro.info";
// export const frontend = "https://bnbchainx.com";
export const frontend = "https://hexafund.uk";
export const dollar = "$";
export const global_account = "19196699";
export const global_account1 = "19196692";
export const global_account3 = "27250377";
export const global_account4 = "18431202";
export const support_mail = "support@oneplus.tech";
// export const withdrawalAddress = "0xc50222c8aC657ff4203C306dD01ca3e3B90A451f"
export const withdrawalAddress = "0xa8656e6ae3b543129b614287cd2ebb687c28d8b6";
export const depositAddress = "0xE7eE24e4e544686b7474E50993447515bBE14004";
export const endpoint = {
  login_api: `${domain}/api/v16/member-login`,
  registration_api: `${domain}/api/v16/member-registration`,
  get_spon_name: `${domain}/api/v16/member-name-by-cust-id`,
  profile_api: `${domain}/api/v16/member-profile-details`,
  user_dashboard_api: `${domain}/api/v16/member-dashboard-details`,
  user_dashboard_business_api: `${domain}/api/v16/member-dashboard-business`,
  get_topup_qr: `${domain}/api/v16/get-topup-qr`,
  member_self_topup: `${domain}/api/v16/member-self-topup`,
  get_report_details: `${domain}/api/v16/get-report-details`,
  get_global_payout_history: `${domain}/api/v16/get-global-payout-history`,
  team_data_api: `${domain}/api/v16/get-member-downline`,
  member_fund_transfer: `${domain}/api/v16/member-fund-transfer-p2p`,
  get_wallet_transactions: `${domain}/api/v16/member-wallet-transactions`,
  member_claimed_pending_transaction: `${domain}/api/v16/member-claim-pending-transaction`,
  get_member_downline_tree: `${domain}/api/v16/get-member-downline-tree`,
  admin_login: `${domain}/api/v16/admin-login`,
  member_list: `${domain}/api/v16/member-details`,
  demo_member_list: `${domain}/api/v16/get-dummy-member-list`,
  user_first_topup_by_admin: `${domain}/api/v16/user-first-topup-by-admin`,
  admin_dashboard: `${domain}/api/v16/get-admin-dashboard`,
  member_payout: `${domain}/api/v16/member-payout`,
  member_payout_report: `${domain}/api/v16/member-payout-report`,
  withdrawal_approval_from_admin: `${domain}/api/v16/withdrawal-approval-from-admin`,
  update_profile: `${domain}/api/v16/change-member-profile-by-user`,
  get_news_and_updates: `${domain}/api/v16/get-news-and-updates`,
  update_news_and_updates: `${domain}/api/v16/update-news-and-updates`,
  update_news_and_updates_status: `${domain}/api/v16/update-news-and-updates-status`,
  get_admin_dashboard: `${domain}/api/v16/get-admin-dashboard`,
  get_member_global_live_transaction_activity: `${domain}/api/v16/get-member-global-live-transaction-activity`,
  get_mt5_account_admin: `${domain}/api/v16/get-mt5-account-admin`,
  create_mt5_account_admin: `${domain}/api/v16/create-mt5-account-admin`,
  update_mt5_account_admin: `${domain}/api/v16/update-mt5-account-admin`,
  change_mt5_account_status: `${domain}/api/v16/change-mt5-account-status`,
  delete_mt5_account_admin: `${domain}/api/v16/delete-mt5-account-admin`,

  user_message: `${domain}/api/v16/user-message`,
  admin_reply: `${domain}/api/v16/admin-reply`,
  get_user_message: `${domain}/api/v16/get-user-messages`,
  get_all_mt5_account_details: `${domain}/api/v16/get-all-mt5-account-details`,

  //////////////////////////////////////////////////

  update_popup_status: `${domain}/api/v16/udpate-popup-status`,

  general_contact_address_api: `${domain}/api/v16/get-api-general-data`,
  paying_dummy_api: `${domain}/api/v16/activation-dummy-request`,
  team_topup_data: `${domain}/api/v16/get-team-topup-details`,
  paying_api: `${domain}/api/v16/activation-request`,
  roi_income_api: `${domain}/api/v16/get-roi-income-details`,
  admin_roi_income_api: `${domain}/api/v16/admin-income-report`,
  admin_fund_memeber: `${domain}/api/v16/admin-fund-member-topup`,
  topup_report: `${domain}/api/v16/topup-report`,
  admin_topup_report: `${domain}/api/v16/admin-topup-report`,
  user_details: `${domain}/api/v16/user-invester-details`,
  admin_user_details: `${domain}/api/v16/admin-invester-details`,
  customer_api: `${domain}/api/v16/get-user-name-by-customer-id`,
  add_wallet_address: `${domain}/api/v16/add-user-wallet-address`,
  update_user_password: `${domain}/api/v16/update-user-password`,
  add_user_withdrawal: `${domain}/api/v16/user-withdrawal-request`,
  withdrawal_list: `${domain}/api/v16/get-withdrawal-details`,
  admin_withdrawal_list: `${domain}/api/v16/admin-withdrawal-report`,
  withdrawal_request: `${domain}/api/v16/withdrawal-request-approval`,
  admin_upload_qr: `${domain}/api/v16/admin-upload-qr`,
  get_admin_upload_qr: `${domain}/api/v16/get-admin-upload-qr`,
  get_user_upload_qr: `${domain}/api/v16/get-user-upload-qr`,
  add_user_fund_request: `${domain}/api/v16/add-user-fund-request`,
  get_user_fund_request: `${domain}/api/v16/get-user-fund-request`,
  admin_paying_report: `${domain}/api/v16/get-admin-fund-request`,
  withdrawal_api: `${domain}/api/v16/withdrawal-req`,
  wallet_user_data: `${domain}/api/v16/get-wallet-data-user`,

  change_status_fund: `${domain}/api/v16/change-fund-request_admin`,
  direct_referral_user: `${domain}/api/v16/user-direct-referral-details`,
  team_downline_user_filterwise: `${domain}/api/v16/user-team-downline-details-filterwise`,
  update_user_profile: `${domain}/api/v16/update-profile`,
  topup_team_id_by_leader: `${domain}/api/v16/topup-team-id-by-leader`,
  forgot_email: `${domain}/api/v16/password-on-mail`,
  check_real_transaction: `${domain}/api/v16/check-real-transactoin`,
  set_withdrawal_limit: `${domain}/api/v16/update-withdrawal-limit`,
  handle_cp_fun: `${domain}/api/v16/handle-cp-status`,
  compounding: `${domain}/api/v16/compound-wallet`,

  //admin
  topup_api: `${domain}/api/v16/admin-topup-id`,
  cp_topup_api: `${domain}/api/v16/team-topup-fund-added-by-admin`,
  get_topup_api: `${domain}/api/v16/get-topup-details-admin`,
  change_topup_status: `${domain}/api/v16/change-topup-status`,
  user_data: `${domain}/api/v16/get-user-details-admin`,
  level_bonus_data: `${domain}/api/v16/get-roi-income-details-admin`,
  get_downline_team: `${domain}/api/v16/get-downline-team`,
  get_upline_team: `${domain}/api/v16/get-upline-team`,
  inr_payout_data: `${domain}/api/v16/get-withdrawal-details-admin`,

  // mt5 data
  mt5_get_data: `${domain}/api/v16/mt5-get-data`,

  // fund transfer
  fund_transfer_income_to_fund_wallet: `${domain}/api/v16/fund-transfer-from-income-to-fund-wallet`,

  // forgot password
  forgot_password: `${domain}/api/v16/forgot-password`,

  /// hexa fund new api's
  user_paying_dummy: `${domain}/api/v16/user-payin-dummy`,
  user_paying_real: `${domain}/api/v16/user-payin-req`,
  get_dummy_user_details: `${domain}/api/v16/get-dummy-user-details`,
};
